module.exports = "<div class=\"scene\" ng-style=\"scene.mainSceneStyle\">\n    <div class=\"scene-bg\" ng-if=\"!scene.hideScene\" ng-style=\"{'background-image': scene.getBgImage()}\">\n\n    </div>\n    <img src=\"{{scene.image}}\" alt=\"photo\" ng-style=\"scene.photoStyle\" ng-class=\"{'no-bg': scene.hidePhotoBg}\">\n    <div class=\"scene-overlay\" ng-if=\"!scene.hideScene\" ng-style=\"{'background-image': scene.getOverlayImage()}\">\n\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./sources/components/common/scene-preview/scene-preview.html
// module id = 716
// module chunks = 0